module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-kowalczyk-06b76ce22a11689e6337d232777857d1.png";